<template>
  <!-- 参数 -->
  <div class="content-item-main">
    <ul class="content-item-side" v-if="groupList && groupList.length > 1">
      <li @click="filterByGroup(null)" :class="!currentGroup ? 'active' : ''">
        {{ $t('com_form_all') }}
      </li>
      <li
        v-for="group in groupList"
        :key="group.groupId"
        :class="currentGroup && currentGroup.groupId === group.groupId ? 'active' : ''"
        @click="filterByGroup(group)"
        :title="group.groupName"
      >
        {{ group.groupName }}
      </li>
    </ul>
    <div class="content-item-list" style="width:100%;">
      <div class="content-item-btn">
        <a-button
          type="green"
          size="small"
          @click="update()"
          icon="plus"
          v-auth="['auth_deviceModel_ctrl_add']"
        >
          {{ $t('com_btn_add') }}
        </a-button>

        <a-button
          type="red"
          size="small"
          @click="deleteBatch()"
          v-if="list && list.length"
          icon="delete"
          v-auth="['auth_deviceModel_ctrl_delete_batch']"
          :disabled="!selectedRowKeys.length"
        >
          {{ $t('com_btn_delete') }}
        </a-button>
      </div>
      <div class="g-table">
        <a-table
          :columns="columns"
          :data-source="listCurrent"
          :pagination="false"
          :rowKey="(_text, index) => _text.id"
          bordered
          :row-selection="
            authList.includes('auth_deviceModel_ctrl_delete_batch') || isSuperAdmin
              ? rowSelection
              : null
          "
          :scroll="{ x: true }"
          :loading="tableLoading"
          size="small"
        >
          <!-- 名称 -->
          <template slot="name" slot-scope="text, record">
            <div
              @click="update(record)"
              style="text-decoration: underline;cursor: pointer;"
              v-if="authList.includes('auth_deviceModel_ctrl_edit') || isSuperAdmin"
            >
              {{ text }}
            </div>
            <div v-else>
              {{ text }}
            </div>
          </template>

          <!-- 时间 -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 操作 -->
          <template slot="Action" slot-scope="text, record">
            <a-button
              type="primary"
              size="small"
              @click="update(record)"
              style="margin-right:15px"
              v-auth="['auth_deviceModel_ctrl_edit']"
              v-if="(currentModel.parentId && !record.parent) || !currentModel.parentId"
            >
              {{ $t('com_btn_edit') }}
            </a-button>

            <a-button
              type="special"
              size="small"
              @click="update(record, true)"
              icon="fork"
              style="margin-right:15px"
              v-auth="['auth_deviceModel_ctrl_add']"
            >
              {{ $t('com_btn_fork') }}
            </a-button>

            <a-button
              type="danger"
              size="small"
              @click="deleteBatch(record.id)"
              v-auth="['auth_deviceModel_ctrl_delete_batch']"
              v-if="(currentModel.parentId && !record.parent) || !currentModel.parentId"
            >
              {{ $t('com_btn_delete') }}
            </a-button>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/model';
import { mapGetters } from 'vuex';

export default {
  props: {
    allGroup: {
      type: [Array, Object],
      default: () => [],
    },
    currentModel: {
      type: Object,
      default: () => {},
    },
    updateFn: {
      type: Function,
      default: () => {},
    },
    scrollEvent: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      groupList: [],
      currentGroup: null,

      selectedRowKeys: [],
      // 参数表头
      tableLoading: false,
      list: [],
      listCurrent: [],
      columns: [
        {
          title: '#',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 60,
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'cmdName',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('deviceModel_form_control_type'),
          align: 'center',
          dataIndex: 'protoEventType',
        },

        {
          title: this.$t('deviceModel_form_control_level'),
          align: 'center',
          dataIndex: 'ctrlLevel',
        },

        {
          title: this.$t('deviceModel_table_param1'),
          dataIndex: 'param1',
          customRender: (text, _record, _index) => {
            return text || '--';
          },
        },

        {
          title: this.$t('deviceModel_table_param2'),
          dataIndex: 'param2',
          customRender: (text, _record, _index) => {
            return text || '--';
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
    rowSelection() {
      return {
        onChange: (selectedRowKeys, _selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            // 非父级才支持多选
            disabled: record.parent,
            name: record.name,
          },
        }),
      };
    },
  },

  created() {
    // 操作
    if (
      this.authList.includes('auth_deviceModel_ctrl_edit') ||
      this.authList.includes('auth_deviceModel_ctrl_delete_batch') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        width: 220,
        scopedSlots: { customRender: 'Action' },
      });
    }
    this.getList();
  },
  methods: {
    // 获取当前Model 参数列表
    getList() {
      this.tableLoading = true;
      API.DeviceModelControlList({ devModelId: this.currentModel.devModelId })
        .then(res => {
          if (res.code === 0) {
            this.list = res.data || [];
            this.filterByGroup(this.currentGroup);

            // 计算当前配置的分类
            const _configGroup = [];
            const groupIds = Array.from(new Set(this.list.map(item => item.groupId)));
            if (this.allGroup && this.allGroup.length) {
              this.allGroup.forEach(item => {
                if (groupIds.includes(item.groupId)) {
                  _configGroup.push(item);
                }
              });
            }
            this.groupList = _configGroup;
          }
        })
        .finally(() => {
          this.tableLoading = false;

          this.scrollEvent();
        });
    },

    // batch delete params item
    deleteBatch(id) {
      let ids = [];
      if (typeof id !== 'undefined') {
        ids.push(id);
      } else {
        ids = this.selectedRowKeys;

        if (!(ids && ids.length)) {
          this.$message.error(this.$t('com_msg_select_item_first'));
          return;
        }
      }

      const h = this.$createElement;
      this.$confirm({
        title:
          ids.length > 1
            ? this.$t('deviceModel_confirm_delete_some_item_title')
            : this.$t('deviceModel_confirm_delete_item_title'),
        content: h('div', {}, [h('p', `Item IDs: ${ids}`)]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.DeviceModelControlDeleteBatch({ ctrlIds: ids.join(',') })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getList();
                this.selectedRowKeys = [];
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 添加/编辑config item
    update(record, fork) {
      this.updateFn('control', record, fork);
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    filterByGroup(group) {
      this.currentGroup = group;

      if (!group) {
        this.listCurrent = this.list;
      } else {
        this.currentGroup = group;
        this.listCurrent = this.list.filter(item => item.groupId === group.groupId);
      }
    },
  },
};
</script>
